import React from 'react'

import cx from 'classnames'

import styles from './styles.module.css'

interface IProps {
  flowB?: boolean
  className?: string
}

const BotVariantIndicator: React.FC<IProps> = ({ flowB, className }) => (
  <span
    className={cx(
      styles.botVariantIndicator,
      { [styles.botVariantIndicatorB]: flowB },
      className
    )}
  >
    {flowB ? 'B' : 'A'}
  </span>
)

export default BotVariantIndicator
